import {
  Directive,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { Subject } from 'rxjs';
import { throttleTime } from 'rxjs/operators';

@Directive({
  selector: '[appThrottleClick]',
  standalone: true,
})
export class ThrottleClickDirective implements OnDestroy {
  @Input() throttleTime = 1000;
  @Output() throttleClick = new EventEmitter();

  private clickSubject = new Subject();

  constructor() {
    this.clickSubject
      .pipe(throttleTime(this.throttleTime))
      .subscribe(() => this.throttleClick.emit());
  }

  @HostListener('click', ['$event'])
  clickEvent(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.clickSubject.next(event);
  }

  ngOnDestroy() {
    this.clickSubject.complete();
  }
}
